/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface AuthenticateWithFirebase200Response
 */
export interface AuthenticateWithFirebase200Response {
    /**
     * 
     * @type {User}
     * @memberof AuthenticateWithFirebase200Response
     */
    user: User;
}

/**
 * Check if a given object implements the AuthenticateWithFirebase200Response interface.
 */
export function instanceOfAuthenticateWithFirebase200Response(value: object): value is AuthenticateWithFirebase200Response {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function AuthenticateWithFirebase200ResponseFromJSON(json: any): AuthenticateWithFirebase200Response {
    return AuthenticateWithFirebase200ResponseFromJSONTyped(json, false);
}

export function AuthenticateWithFirebase200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticateWithFirebase200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
    };
}

export function AuthenticateWithFirebase200ResponseToJSON(json: any): AuthenticateWithFirebase200Response {
    return AuthenticateWithFirebase200ResponseToJSONTyped(json, false);
}

export function AuthenticateWithFirebase200ResponseToJSONTyped(value?: AuthenticateWithFirebase200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
    };
}

